import Offcanvas from 'react-bootstrap/Offcanvas';
import {useEffect, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";
import axiApi from "ApiCaller";
import SwalAlert from "core/swalAlert";

const FormPlugin = (props) => {
    const [tF] = useTranslation("forms");
    const swalShow = new SwalAlert(tF("labels.accept"))
    const formData = useRef({});

    const handleClose = () => props.setShowForm(false);

    const handleChange = (event) => {
        const {name, value} = event.target;
        formData.current[name] = value;
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (Object.keys(formData.current).length) {
            let dataSend = {
                key: props.plugin.key,
                params: formData.current
            };

            axiApi.post("/api/plugin/params/", dataSend)
                .then((resp) => {
                    if (resp.data.status) {
                        let key;
                        for (key in formData.current){
                            props.plugin.params[key].value = formData.current[key]
                        }
                        let itemsM = props.items;
                        itemsM[props.plugin.idx] = props.plugin;
                        props.setItems(itemsM);

                        swalShow.success(
                            tF("success.title")
                        ).then(() => {
                            props.setShowForm(false)
                        })
                    } else {
                        swalShow.warning(
                            tF("errors.title"),
                            tF("errors.server-error")
                        )
                    }

                })
                .catch((error) => {
                    console.error(error);
                    swalShow.warning(
                        tF("errors.title"),
                        tF("errors.server-error")
                    )
                })


        }
    }


    useEffect(() => {
        let plug;
        for (plug in props.plugin.params) {
            formData.current[plug.name] = plug.value
        }
    }, []);


    return (
        <Offcanvas show={props.showForm} onHide={handleClose} placement="end" backdrop="static"
                   style={{width: "50%"}}>
            <Offcanvas.Header className="preview-canvas" closeButton>
                <div className="preview-icon">
                    <FontAwesomeIcon icon="plug"/>
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>Plugin {props.plugin.name}</Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="m-auto col-md-8 col-12">

                            {Object.keys(props.plugin.params).map((param, idx) => (
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalPassword" key={idx}>
                                    <Form.Label column sm={2}>
                                        {tF(props.plugin.params[param].label)}
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            type={props.plugin.params[param].type}
                                            name={param}
                                            defaultValue={props.plugin.params[param].value}
                                            onChange={handleChange}
                                            required={props.plugin.params[param].required}
                                        />
                                    </Col>
                                </Form.Group>
                            ))}

                        </div>
                    </div>
                    <div className="text-center col-12 mb-4 position-relative fixed-bottom">
                        <button type="button" className="btn btn-secondary me-4" onClick={() => {
                            props.setShowForm(false)
                        }}>Cancelar
                        </button>
                        <button type="submit" className="btn btn-primary">Guardar</button>
                    </div>
                </Form>
            </Offcanvas.Body>

        </Offcanvas>

    );
}

export default FormPlugin
